export default __webpack_public_path__ + "static/media/HelveticaNeueLT-Roman.24aab4a9.eot";